'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaCompress = function FaCompress(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20.1 21.4v10q0 0.6-0.4 1t-1 0.5-1-0.5l-3.2-3.2-7.4 7.4q-0.2 0.3-0.5 0.3t-0.5-0.3l-2.6-2.5q-0.2-0.2-0.2-0.5t0.2-0.5l7.4-7.5-3.2-3.2q-0.4-0.4-0.4-1t0.4-1 1-0.4h10q0.6 0 1 0.4t0.4 1z m16.9-15q0 0.3-0.2 0.5l-7.4 7.5 3.2 3.2q0.4 0.4 0.4 1t-0.4 1-1 0.4h-10q-0.6 0-1-0.4t-0.5-1v-10q0-0.6 0.5-1t1-0.5 1 0.5l3.2 3.2 7.4-7.4q0.2-0.3 0.5-0.3t0.5 0.3l2.6 2.5q0.2 0.2 0.2 0.5z' })
        )
    );
};

exports.default = FaCompress;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/compress.js
// module id = 1156
// module chunks = 0